import styled from "styled-components";

export const FilterContainer = styled.div`
  display: flex;
`;

export const FiltersModal = styled.div `
`
